/*
 * all_suggestions.js
 *
 * This file contains categorized suggestions for your chatbot.
 * You can import and use any array you want in the Suggestions component.
 */

const all_suggestions = {
  course_recommendation: [
    "När kan jag starta min distansutbildning?",
    "Vilka är era 3 bästa utbildningar?",
    "Vad är eStädkvalitet?",
  ],
};

export default all_suggestions;

